import React from "react";

const SearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58268 18.125C4.87435 18.125 1.04102 14.2916 1.04102 9.58329C1.04102 4.87496 4.87435 1.04163 9.58268 1.04163C14.291 1.04163 18.1243 4.87496 18.1243 9.58329C18.1243 14.2916 14.291 18.125 9.58268 18.125ZM9.58268 2.29163C5.55768 2.29163 2.29102 5.56663 2.29102 9.58329C2.29102 13.6 5.55768 16.875 9.58268 16.875C13.6077 16.875 16.8743 13.6 16.8743 9.58329C16.8743 5.56663 13.6077 2.29163 9.58268 2.29163Z"
        fill="#292D32"
      />
      <path
        d="M18.3326 18.9583C18.1742 18.9583 18.0159 18.9 17.8909 18.775L16.2242 17.1083C15.9826 16.8666 15.9826 16.4666 16.2242 16.225C16.4659 15.9833 16.8659 15.9833 17.1076 16.225L18.7742 17.8916C19.0159 18.1333 19.0159 18.5333 18.7742 18.775C18.6492 18.9 18.4909 18.9583 18.3326 18.9583Z"
        fill="#292D32"
      />
    </svg>
  );
};

export default SearchIcon;
